import { CircleDashed } from "lucide-react";
import { cn } from "@/lib/utils";

interface LoadingScreenProps {
  text?: string;
  className?: string;
}

export function LoadingScreen({
  text = "Loading...",
  className,
}: Readonly<LoadingScreenProps>) {
  return (
    <div
      className={cn(
        "flex h-svh flex-col items-center justify-center gap-3",
        className,
      )}
    >
      <CircleDashed className="text-primary h-8 w-8 animate-spin" />
      <p className="text-muted-foreground text-sm">{text}</p>
    </div>
  );
}
